import React from 'react';
import { PublicLayout } from '@/components/Layout/PublicLayout';

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <PublicLayout
      title="Privacy Policy"
    >
      <div className="space-y-6 text-sm sm:text-base text-slate-700 leading-relaxed">
        
        {/* Section 1 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            1. Information We Collect
          </h3>
          <p>
            We may collect your name, telephone number, email address, delivery address, order information, payment or transaction information, and information you provide when contacting us.
          </p>
        </section>

        {/* Section 2 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            2. How We Use Your Information
          </h3>
          <p>
            We use your information to manage your account, process and deliver orders, process payments, provide order tracking, communicate with you, handle cancellations and returns, improve our services, prevent fraud and comply with legal requirements.
          </p>
        </section>

        {/* Section 3 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            3. Sharing Information
          </h3>
          <p>
            We may share relevant information with service providers who help operate the App and fulfil orders, such as delivery, payment, hosting and technology providers. We may also disclose information where required by law.
          </p>
        </section>

        {/* Section 4 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            4. Protecting Your Information
          </h3>
          <p>
            We take reasonable measures to protect personal information against unauthorised access, loss, misuse or disclosure. No electronic system can be guaranteed completely secure.
          </p>
        </section>

        {/* Section 5 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            5. Your Rights
          </h3>
          <p>
            Subject to applicable law, you may request access to or correction of personal information held by Yebo Eggs and exercise other rights provided by POPIA.
          </p>
        </section>

        {/* Section 6 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            6. Marketing
          </h3>
          <p>
            Where required, we will obtain appropriate consent before sending promotional communications. You may unsubscribe where applicable.
          </p>
        </section>

        {/* Section 7 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            7. Changes
          </h3>
          <p>
            We may update this Privacy Policy from time to time. The latest version will be made available through the App.
          </p>
        </section>

        {/* Section 8 */}
        <section className="space-y-2">
          <h3 className="text-base sm:text-lg font-bold text-slate-900">
            8. Contact
          </h3>
          <p>
            For privacy-related questions or requests, use the contact details provided in the App.
          </p>
        </section>

      </div>
    </PublicLayout>
  );
};
